<template lang="pug">
    .is-actions(v-if="actions.length !== 0" @mouseleave="showActionsList = false")
        .actions-wrapper(@mouseover="showActionsList = true")
            .actions-trigger
                svg-icon(name='dots' size='small')
            .actions-items( v-if="showActionsList" :style="{top: yCorrection + 'px'}")
                .actions-item(@click.stop="handleClick(action.action)" v-for="action in actions")
                    svg-icon(name='trash' size='small' :title="action.label")
    .is-noactions(v-else)
        .actions-wrapper
            .actions-trigger -
</template>

<script>
export default {
    name: 'ActionsMenu',
    props: {
        actions: { type: Array, required: true }
    },

    data() {
        return {
            showActionsList: false,
            yCorrection: 0
        }
    },
    methods: {
        handleClick(action) {
            action()
            this.showActionsList = false
        }
    }
}
</script>
